module.exports={
   "firebase": {
      "apiKey": "AIzaSyBwjOsRaH-aSh2PhEl66GzXYcasy46dVPk",
      "authDomain": "form-engine-test.firebaseapp.com",
      "databaseURL": "https://form-engine-test.firebaseio.com",
      "projectId": "form-engine-test",
      "storageBucket": "form-engine-test.appspot.com",
      "messagingSenderId": "914821891445",
      "functionsBaseUrl": "https://api-test.formengine.com",
      "localPort": 5001
   }
}